<template>
  <div>
    <Search
      v-model="search"
      v-on:handleClick="handleSearchButton"
    />

    <div
      class="selection-module-video"
      v-on:scroll="handleScroll"
    >
      <div
        class="row-extra-small"
      >
        <div
          class="col-8 col-12-md selection-module-video--videos"
          v-for="(item, index) of videos"
          v-bind:key="index"
          v-on:click="handleClick(item, index)"
        >
          <RatioBlockImage
            :src="item.preview"
          />

          <p class="selection-module-video--title">{{ item.title }}</p>

          <p>{{ item.createddate }}</p>
        </div>

        <p
          v-if="videos.length === 0"
          class="selection-module-video--error"
        >
          No results found 😟
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { API } from '../../../services/api.ts'
  import Search from '../../form/search.vue'
  import Dropdown from '../../dropdown/dropdown.vue'  
  import Button from '../../buttons/button.vue'
  import RatioBlockImage from '../../ratioBlock/ratioBlockImage.vue'
  import Modal from '../../modal/modal.vue'

  export default {
    name: 'SelectionModuleVideo',
    components: {
      Search,
      Dropdown,
      Button,
      RatioBlockImage,
      Modal
    },
    data () {
      return {
        list: [],
        videos: [],
        search: '',
        scrollTop: 0,
        currentPage: 1,
        pages: 0,
        isLoading: false
      }
    },
    methods: {
      handleScroll() {
        let selectionModuleImage = this.$el.querySelector('.selection-module-image');

        if (this.scrollTop + 300 < selectionModuleImage.scrollTop) {
          this.scrollTop += 300;
          this.currentPage += 1;

          if (this.pages !== this.currentPage) {
            API.post(
              `index.cfm?act=videos.search`,
              {
                extension: 'mp3',
                page: this.currentPage,
                keyword: this.search
              }
            ).then(
              response => {
                const calcPages = Math.ceil(response.data.data.totalItems / response.data.data.itemsPerPage);

                this.pages = calcPages;
                this.videos = this.videos.concat(response.data.data.items);

                console.log(response);
              }
            )
          }
        }
      },
      handleClick: function(image, index) {
        this.$emit('handleClick', image)

        let videos = this.$el.querySelectorAll('.selection-module-video--videos');
        
        for (let i = 0; i < videos.length; i++) {
          const element = videos[i];
          element.style.border = '0';
        }

        videos[index].style.border = '2px solid #2699fb';
      },
      handleSearchButton: function() {
        API.post(
          `index.cfm?act=videos.search`,
          {
            keyword: this.search
          }
        ).then(
          response => {
            this.videos = response.data.data.items
            this.scrollTop = 0;
            this.pages = 0;
            this.currentPage = 0;
            console.log(response.data.data.items)
          }
        )
      }
    },
    mounted() {
      API.post(
        `index.cfm?act=videos.search`
      ).then(
        response => {
          const calcPages = Math.ceil(response.data.data.totalItems / response.data.data.itemsPerPage);

          this.pages = calcPages
          this.videos = response.data.data.items

          console.log(response);
        }
      )

      API.post(
        `index.cfm?act=videos.search`
      ).then(
        response => {
          const calcPages = Math.ceil(response.data.data.totalItems / response.data.data.itemsPerPage);

          this.pages = calcPages;
          this.videos = response.data.data.items;

          console.log(response);
        }
      )

      API.post(
        `index.cfm?act=videos.filteroptions`,
      ).then(
        response => {
          console.log('filteroptions', response.data.data);
          this.list = response.data.data.dates;
        }
      )
    }
  }
</script>

<style lang="scss">
  @import "../../../styles/components/mediaQueries.scss";

  .selection-module-video {
    border: 1px solid var(--blue-medium);
    padding: 5px 5px 0 5px;
    box-sizing: border-box;
    max-height: 230px;
    overflow: scroll;
    margin-bottom: 15px;

    &--title {
      font-weight: bold;
    }
    
    &--videos {
      margin-bottom: 10px;      
      cursor: pointer;

      p {
        padding-bottom: 0;
      }
      
      span {
        font-weight: normal;
        margin-bottom: 5px;
      }

      .ratio--wrapper {
        border: 1px solid var(--grey-light);

        &:hover {
          border: 1px solid var(--blue);
        }
      }
    }

    &--error {
      text-align: center;
      width: 100%;
      padding-top: 10px;
    }
  }  
</style>
